import {IMessageData, ISyncStepStatus, TRouteId} from "../../index";
import {SPINNER} from "../../constants";
import {global} from "../../appContext";
import {nsSync} from "../../util/nsSync";
import {getWebServiceUrl} from "../../util/misc";
import {getHash} from "../../constants/RouteDefinitions";
import * as ko from "knockout";

export let template: string = lastsyncHtml;

import SyncStatus = nsSync.SyncStatus;
import lastsyncHtml from './lastsync.html?raw';

export class viewModel {
    private syncFile: { orgnr: string; id: number; url: string; token: string };

    constructor(private data: ISyncStepStatus) {
        this.syncFile = {
            id: data.importfileid,
            url: `${getWebServiceUrl('getimportfile')}?rnd=${Math.random()}`,
            token: global.login.getToken(),
            orgnr: data.orgnr,
        }
    }

    statusMessage = ko.pureComputed((): IMessageData => {
        switch (this.getSyncCycleStatus()) {
            case SyncStatus.Executed:
                return {
                    message: `completed`,
                    type: "success"
                };
            case SyncStatus.Halted: {
                const reason: string = this.data.result || 'unknown';
                return {
                    message: `((stopped)) <div class="margin--top-xsmall">((reason)): ${reason}</div>`,
                    type: "danger"
                };
            }
            case SyncStatus.Executing:
                return {
                    message: `((ongoing|td)) ${SPINNER}`,
                    type: "info"
                };
            default:
                return {
                    message: `unknown`,
                    type: "info"
                };
        }
    });

    private getSyncCycleStatus(): SyncStatus {
        return nsSync.getSyncStatus(this.data)
    }

    private getHash(id: TRouteId, params: any) {
        return getHash(id, params, true, this.data.orgnr)
    }

    private onOrgSwitchClicked() {
        global.login.setSelectedOrganizationById(this.data.orgnr)
    }

}
